import styled from "@emotion/styled";

export const UpperSectionCardRow = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  width: clamp(350px, 80%, 1200px);
  margin-top: -30px;
  margin-bottom: 80px;
  padding: clamp(10px, 2%, 20px) 0;
  gap: clamp(30px, 40px, 50px);

  @media (max-width: 780px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: static;      
    left: auto;      
    transform: none; 
    margin-top: 0;
    margin-bottom: 40px; 
    width: 95%;            
    padding: clamp(10px, 5%, 10px) 0; 
  }
`;
